
document.addEventListener("DOMContentLoaded", () => {
  // ===== Simple config: choose how SIZE should look =====
  // Allowed values: "buttons" or "select"
  const CONFIG = {
    sizeModeDesktop: "buttons", // desktop layout (>= 750px)
    sizeModeMobile: "select"    // mobile layout (< 750px)
  };

  const isMobile = window.matchMedia("(max-width: 749px)").matches;
  const sizeMode = isMobile ? CONFIG.sizeModeMobile : CONFIG.sizeModeDesktop;

  // For each product card that has our variants JSON
  document.querySelectorAll("[data-variants-json]").forEach((jsonEl) => {
    let variants;

    try {
      variants = JSON.parse(jsonEl.textContent.trim());
    } catch (e) {
      console.error("Failed to parse variants JSON", e);
      return;
    }

    if (!variants || !variants.length) return;

    const card = jsonEl.closest(".card-wrapper");
    if (!card) return;

    // --- Swatch JSON (from Liquid) ---
    let swatchMap = {};
    const swatchJsonEl = card.querySelector("[data-swatch-json]");
    if (swatchJsonEl) {
      try {
        swatchMap = JSON.parse(swatchJsonEl.textContent.trim()) || {};
      } catch (e) {
        console.warn("Failed to parse swatch JSON", e);
      }
    }

    // Find the inline product form used by Dawn quick add
    const productForm = card.querySelector("product-form");
    if (!productForm) return;

    const form = productForm.querySelector("form");
    if (!form) return;

    const variantInput = form.querySelector("input[name='id']");
    if (!variantInput) return;

    const mediaImg = card.querySelector(".card__media img");

    // ===== Build picker containers =====
    const pickerWrapper = document.createElement("div");
    pickerWrapper.classList.add("collection-variant-picker");

    const colorWrapper = document.createElement("div");
    colorWrapper.classList.add("cvp-color-wrapper");

    const sizeWrapper = document.createElement("div");
    sizeWrapper.classList.add("cvp-size-wrapper");

    pickerWrapper.appendChild(colorWrapper);
    pickerWrapper.appendChild(sizeWrapper);

    // Insert picker right after the price / card-information block
    const cardInfo = card.querySelector(".card__content:last-of-type .card-information");

    if (cardInfo && cardInfo.parentNode) {
      // Put swatches immediately after the block that contains the price
      cardInfo.parentNode.insertBefore(pickerWrapper, cardInfo.nextSibling);
    } else {
      // Fallback: keep old behaviour if we can't find card-information
      form.parentNode.insertBefore(pickerWrapper, form);
    }

    // ===== Work out unique colors & sizes (assumes option1 = Color, option2 = Size) =====
    const colors = [...new Set(variants.map(v => v.options[0]))].filter(Boolean);
    const sizes  = [...new Set(variants.map(v => v.options[1]))].filter(Boolean);

    // ===== Render color buttons (swatch dots, no label) =====
    colors.forEach(color => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cvp-color";
      btn.dataset.value = color;

      // Inner swatch element
      const swatchEl = document.createElement("span");
      swatchEl.className = "cvp-color-swatch";

      const info = swatchMap[color];

      if (info) {
        // Image swatch
        if (info.image) {
          swatchEl.style.backgroundImage = `url(${info.image})`;
          swatchEl.classList.add("cvp-color-swatch--image");
        }
        // Color swatch
        if (info.color) {
          swatchEl.style.setProperty("--cvp-color-swatch", info.color);
        }
      }

      btn.appendChild(swatchEl);
      colorWrapper.appendChild(btn);

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation(); // don’t bubble up to card-click.js
        colorWrapper.querySelectorAll("button").forEach(b => b.classList.remove("active"));
        btn.classList.add("active");
        updateVariant();
      });
    });

    // ===== Render SIZE as either buttons or select =====
    let sizeSelect = null; // will hold <select> if we use it

        if (sizes.length) {
      if (sizeMode === "select") {
        // ---- Dropdown version ----
        sizeSelect = document.createElement("select");
        sizeSelect.className = "cvp-size-select";

        // Placeholder option (optional)
        const placeholder = document.createElement("option");
        placeholder.value = "";
        placeholder.textContent = "Select size";
        sizeSelect.appendChild(placeholder);

        sizes.forEach(size => {
          const opt = document.createElement("option");
          opt.value = size;
          opt.textContent = size;
          sizeSelect.appendChild(opt);
        });

        sizeWrapper.appendChild(sizeSelect);

        // 🔒 Stop card click behaviour from hijacking the select
        ["click", "mousedown", "mouseup", "touchstart"].forEach(evt => {
          sizeSelect.addEventListener(evt, (e) => {
            e.stopPropagation();
          });
        });

        sizeSelect.addEventListener("change", (e) => {
          e.stopPropagation(); // just in case
          // Clear any button "active" state if it exists (for future-proofing)
          sizeWrapper.querySelectorAll(".cvp-size").forEach(b => b.classList.remove("active"));
          updateVariant();
        });

      } else {
        // ---- Buttons version (your current behaviour) ----
        sizes.forEach(size => {
          const btn = document.createElement("button");
          btn.type = "button";
          btn.className = "cvp-size";
          btn.textContent = size;
          btn.dataset.value = size;
          sizeWrapper.appendChild(btn);

          btn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation(); // don’t bubble up to card-click.js
            sizeWrapper.querySelectorAll("button").forEach(b => b.classList.remove("active"));
            btn.classList.add("active");
            updateVariant();
          });
        });
      }
    }


    // ===== Variant selection + image update =====
    function updateVariant() {
      const selectedColor = colorWrapper.querySelector(".active")?.dataset.value;

      // Size may come from button OR select:
      let selectedSize = null;

      const activeSizeBtn = sizeWrapper.querySelector(".cvp-size.active");
      if (activeSizeBtn) {
        selectedSize = activeSizeBtn.dataset.value;
      } else if (sizeSelect) {
        selectedSize = sizeSelect.value || null;
      }

      if (!selectedColor || !selectedSize) return;

      const match = variants.find(v =>
        v.options[0] === selectedColor && v.options[1] === selectedSize
      );

      if (!match) return;

      // Update hidden variant ID for Dawn's product-form.js
      variantInput.value = match.id;

      // Update image to the variant image if we have one
      if (match.featured_image_url && mediaImg) {
        mediaImg.src = match.featured_image_url;
        mediaImg.srcset = `${match.featured_image_url} 533w`;
      }
      // Dawn still handles the actual add-to-cart on submit
    }

    // Auto-select first available combination on load
    const firstVariant = variants.find(v => v.available) || variants[0];
    if (firstVariant) {
      // Preselect color button
      const firstColorBtn = Array.from(colorWrapper.children)
        .find(b => b.dataset.value === firstVariant.options[0]);
      if (firstColorBtn) firstColorBtn.classList.add("active");

      // Preselect size based on mode
      if (sizeMode === "select" && sizeSelect) {
        sizeSelect.value = firstVariant.options[1] || "";
      } else {
        const firstSizeBtn = Array.from(sizeWrapper.children)
          .find(b => b.dataset.value === firstVariant.options[1]);
        if (firstSizeBtn) firstSizeBtn.classList.add("active");
      }

      updateVariant();
    }
  });
});
